import { BrowserRouter } from "react-router-dom";
import { AppRouter } from "@/app/AppRouter";
import { SiteLanguageProvider } from "@/features/preferences/SiteLanguageContext";
import "@/App.css";

function App() {
  return (
    <BrowserRouter>
      <SiteLanguageProvider>
        <AppRouter />
      </SiteLanguageProvider>
    </BrowserRouter>
  );
}

export default App;
